import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const Button = ({
  href,
  children,
  origin,
  onClick = null,
  backgroundColor = "bg-visOrange",
  py = "py-[0.25rem] md:py-[0.60rem]",
  px = "",
}) => {
  let defultOrigin = "origin-center";

  if (origin) {
    defultOrigin = origin;
  }

  return (
    <>
      <motion.span
        onClick={onClick}
        whileHover={{
          scale: 1.1,
          cursor: "pointer",
          transition: { type: "spring", stiffness: 400, damping: 15 },
        }}
        className={`block w-fit ${backgroundColor} font-semibold text-white ${defultOrigin} rounded-sm`}
      >
        <NavLink className={`flex ${px} ${py}`} to={href}>
          {children}
        </NavLink>
      </motion.span>
    </>
  );
};

export default Button;
